import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Box,
    Text,
    useColorModeValue,
    Icon
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import { getPersonas, reset } from "../../features/personaSlice";
import { ToastChakra } from '../../helpers/toast';
import { FiChevronLeft, FiChevronRight, FiChevronsLeft, FiChevronsRight } from 'react-icons/fi';

export const ModalBuscarPersona = ({ isOpen, onClose, onSelectPersona }) => {
    const dispatch = useDispatch();
    const themeTable = useColorModeValue("default", "solarized");

    const { personas, isError, message, totalRows } = useSelector((state) => state.persona);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);

    useEffect(() => {
        dispatch(getPersonas({ page, perPage }));
        return () => dispatch(reset());
    }, [page, perPage]);

    useEffect(() => {
        if (isError && message) {
            ToastChakra("Error", message, "error", 3000);
            console.log(message);
        }
    }, [isError, message]);

    const handlePageChange = (page) => setPage(page);
    const handleRowsPerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        setPage(1);
    };

    const columns = [
        {
            name: "CEDULA",
            selector: row => row?.cedula,
            sortable: true
        },
        {
            name: "NOMBRE",
            selector: row => `${row?.nombre} ${row?.apellido}`,
            sortable: true
        },
        {
            name: "EMAIL",
            selector: row => row?.email,
            sortable: true
        },
    ];

    const tableData = {
        columns: columns,
        data: personas
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
            <ModalOverlay  bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'/>
            <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl">
                <ModalHeader textAlign="center">Buscar Persona</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Box
                        overflow="hidden"
                        boxShadow={"base"}
                        bg="white"
                        _dark={{ bg: "primary.1000" }}
                        mt={2}
                        pt={2}
                        rounded="2xl"
                    >
                        <DataTableExtensions
                            {...tableData}
                            print={false}
                            exportHeaders={false}
                            export={false}
                            filterPlaceholder="Buscar persona..."
                            numberOfColumns={columns.length}
                            fileName={"PERSONAS_" + new Date().toLocaleDateString()}
                        >
                            <DataTable
                                columns={columns} // sin la columna "ACCIÓN"
                                data={personas}
                                onRowClicked={onSelectPersona} // esta función recibe la fila (row) como parámetro
                                pointerOnHover
                                highlightOnHover
                                defaultSortField="createdAt"
                                pagination
                                paginationIconFirstPage={<Icon as={FiChevronsLeft} boxSize={6} _dark={{ color: "gray.300" }} />}
                                paginationIconLastPage={<Icon as={FiChevronsRight} boxSize={6} _dark={{ color: "gray.300" }} />}
                                paginationIconPrevious={<Icon as={FiChevronLeft} boxSize={6} _dark={{ color: "gray.300", _hover: { color: "white" } }} />}
                                paginationIconNext={<Icon as={FiChevronRight} boxSize={6} _dark={{ color: "gray.300", _hover: { color: "white" } }} />}
                                paginationServer
                                paginationPerPage={perPage}
                                onChangeRowsPerPage={handleRowsPerPageChange}
                                paginationRowsPerPageOptions={[5, 10, 15, 20, 30]}
                                paginationTotalRows={totalRows}
                                onChangePage={handlePageChange}
                                paginationDefaultPage={page}
                                theme={themeTable}
                                responsive
                               // highlightOnHover
                               // pointerOnHover
                                noDataComponent={<Text fontSize="lg">No se encontraron datos</Text>}
                                customStyles={{ rows: { style: { cursor: "pointer" } } }}
                            />
                        </DataTableExtensions>
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
